<div class="grid">
    <div class="mb-4 w-1/2 mx-auto text-center">
        <p-selectButton class="w-full" [options]="pageOptions" (ngModelChange)="selecionarOpcao($event.value)"
            [(ngModel)]="pageConfigs" optionLabel="name">
            <ng-template let-option pTemplate="item">
                <div class="flex align-items-center justify-content-center w-full">
                    <i [ngClass]="option.icon" class="mr-2"></i>
                    <span class="font-bold">{{ option.name }}</span>
                </div>
            </ng-template>
        </p-selectButton>
    </div>
</div>
<div class="grid ss-l-marginProfileConfig" *ngIf="activeOption == 1">
    <div class="col-12 xl:col-6">
        <div class="card">
            <div class="flex align-items-start justify-content-between mb-2">
                <span class="text-900 text-xl font-semibold">Informações da loja</span>
            </div>
            <div>
                <div>Essas informações serão exibidas para seus clientes e em mecanismos de busca (ex.: Google).
                </div>
            </div>
            <div class="col-12 mb-4 mt-4 p-0">
                <label class="w-full ss-g-globalClassLabel">
                    Nome da loja
                    <div class="p-inputgroup mt-2">
                        <input type="text" id="title" (keypress)="filterSpecialChars($event)"
                            (input)="formToSave1(); checkInput();" pInputText class="w-full" [(ngModel)]="storeName">
                    </div>
                </label>
                <div class="flex align-items-center justify-content-between mt-2">
                    <!-- Mensagem de Erro à esquerda -->
                    <span *ngIf="errorName" class="p-error">
                        O nome não pode estar vazio
                    </span>
                </div>
            </div>
            <div class="col-12 mt-4 p-0">
                <label class="w-full ss-g-globalClassLabel">
                    Descrição da loja
                    <div class="mb-2 mt-2">
                        <textarea rows="3" (ngModelChange)="formToSave1()" cols="30"
                            class="w-full p-inputtextarea p-inputtext p-component p-element"
                            placeholder="Descrição do Slick" [(ngModel)]="storeDescription" pInputTextarea></textarea>
                    </div>
                </label>
            </div>
        </div>
        <div class="card">
            <div class="flex align-items-start justify-content-between mb-2">
                <span class="text-900 text-xl font-semibold">URL da loja</span>
            </div>
            <div>
                <div>Esse é o endereço URL usado para acessar a loja</div>
            </div>
            <div class="col-12 mb-4 mt-4 p-0">
                <label class="w-full ss-g-globalClassLabel">
                    URL
                    <div class="p-inputgroup mt-2">
                        <span class="p-inputgroup-addon">https://slicksell.link/</span>
                        <input id="urlStore" (keypress)="filterSpecialCharsUrl($event)" (ngModelChange)="formToSave3()"
                            type="text" pInputText placeholder="sua-loja" [(ngModel)]="urlStore" />
                        <!-- <span class="p-inputgroup-addon">.slicksell.com.br</span> -->
                    </div>
                </label>
                <div class="flex align-items-center justify-content-between mt-2">
                    <!-- Mensagem de Erro à esquerda -->
                    <span *ngIf="errorURL" class="p-error">
                        {{message}}
                    </span>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="flex align-items-start justify-content-between mb-2">
                <span class="text-900 text-xl font-semibold">URL do Site</span>
            </div>
            <div>
                <div>Esse é o endereço URL usado para acessar seu site</div>
            </div>
            <div class="col-12 mb-4 mt-4 p-0">
                <label class="w-full ss-g-globalClassLabel">
                    URL
                    <div class="p-inputgroup mt-2">
                        <span class="p-inputgroup-addon">https://</span>
                        <input id="urlSite" type="text" pInputText placeholder="nome-do-site.com"
                            [(ngModel)]="store_site" (keypress)="filterSpecialCharsUrlSite($event)"
                            (blur)="validateSiteDomain()" (ngModelChange)="formToSave2()" />
                    </div>
                </label>
            </div>
        </div>
        <div class="card">
            <div class="flex align-items-start justify-content-between mb-2">
                <span class="text-900 text-xl font-semibold">Status da loja</span>
            </div>
            <div>Para desabilitar o acesso a sua loja habilite o <b>modo de manutenção</b>.</div>
            <div class="col-12 mb-4 mt-4 p-0">
                <div class="flex align-items-center gap-2">
                    <p-inputSwitch binary="true" (ngModelChange)="formToSave1()" class="mr-2 ss-l-switch-position3"
                        [(ngModel)]="manutantionMode" [ngModelOptions]="{standalone: true}"></p-inputSwitch>
                    <label>Modo de manutenção</label>
                </div>
            </div>
        </div>

        <!-- <div class="card">
            <div class="flex align-items-start justify-content-between mb-2">
                <span class="text-900 text-xl font-semibold">Creators</span>

            </div>
            <div class="col-12 mb-4 mt-4 p-0">
                <div class="flex align-items-center gap-2">
                    <div class="flex align-items-center gap-2">
                        <p-inputSwitch [(ngModel)]="creatorsScreen" (onChange)="onChangePushNews()"></p-inputSwitch>
                        <label class="ml-2">Exibir Tela de Integração para creators</label>
                    </div>
                </div>
            </div>
        </div> -->

    </div>
    <div class="col-12 xl:col-6">
        <div class="card mt-0  ">
            <div class="text-900 text-xl font-semibold mb-2">Identidade visual</div>
            <div class="col-12 p-0 mb-2">
                <div>Carregue as logos de sua loja</div>
            </div>


            <!---->
            <div class="col-12 p-0 grid mx-0 w-full surface-border border-bottom-1">
                <div class="col-6 mt-3 mb-2 pl-0">
                    <span class="ss-g-globalClassLabel flex-start" style="align-self:flex-start">Logotipo da loja</span>
                    <div class="mt-3"></div>
                    <app-upload-file #uploadFile [accept]="'image'" [previewUrl]="logoPreviewUrl"
                        [errorSize]="erroTamanhoImagem" [errorType]="erroTipoImagem" [required]="true"
                        [requiredError]="showRequiredError" [fileName]="selectedFile?.name || null"
                        [previewVariant]="'logo'"
                        (fileSelected)="handleManualFileUpload($event)" (removeFile)="removelogo()"
                        (fileInvalid)="handleFileInvalid($event)" (fileValid)="handleFileValid()">
                    </app-upload-file>



                </div>
                <div class="col-6 mt-3 mb-2 pr-0">
                    <span class="ss-g-globalClassLabel flex-start" style="align-self:flex-start">Favicon da loja</span>
                    <div class="mt-3"></div>

                    <app-upload-file #faviconUpload [accept]="'image'" [previewUrl]="faviconPreviewUrl"
                        [errorSize]="erroTamanhoImagem2" [errorType]="erroTipoImagem2" [required]="true"
                        [requiredError]="showRequiredError" [fileName]="selectedFileFavicon?.name || null"
                        [previewVariant]="'logo'"
                        (fileSelected)="handleManualFaviconUpload($event)" (removeFile)="removelogoFavicon()"
                        (fileInvalid)="handleFileInvalid2($event)" (fileValid)="handleFileValid2()">
                    </app-upload-file>



                </div>
                <div class="col-12 mt-3 mb-2 pl-0 pr-0">
                    <span class="ss-g-globalClassLabel flex-start" style="align-self:flex-start">Wallpaper da
                        loja</span>
                    <div class="mt-3"></div>

                    <app-upload-file #wallpaperUpload [accept]="'image'" [previewUrl]="wallpaperPreviewUrl"
                        [errorSize]="erroTamanhoImagemWallpaper" [errorType]="erroTipoImagemWallpaper" [required]="true"
                        [requiredError]="showRequiredError" [fileName]="selectedFileWallpaper?.name || null"
                        [previewVariant]="'wallpaper'"
                        (fileSelected)="handleManualWallpaperUpload($event)" (removeFile)="removeWallpaper()"
                        (fileInvalid)="handleFileInvalidWallpaper($event)" (fileValid)="handleFileValidWallpaper()">
                    </app-upload-file>



                </div>
            </div>
            <div class="col-12 p-0 grid mx-0 mt-4 w-full">
                <div class="flex align-items-start justify-content-between mb-2">
                    <span class="text-900 text-xl font-semibold">Cores</span>
                </div>
                <div class="col-12 p-0 mb-2">
                    <div>Defina as cores da loja</div>
                </div>
                <div class="col-12 mb-4 mt-2 p-0">
                    <div class="col-12 p-0 mb-2">
                        <label class="ss-g-globalClassLabel">Primária</label>
                        <div class="mt-2"></div>
                        <p-colorPicker [(ngModel)]="primaryColor" format="hex" (ngModelChange)="formToSave2()"
                            (onChange)="updatePrimaryColor($event.value)" class="w-full"></p-colorPicker>
                    </div>
                    <div class="col-12 p-0">
                        <label class="ss-g-globalClassLabel mt-2">Secundária</label>
                        <div class="mt-2"></div>
                        <p-colorPicker [(ngModel)]="secondaryColor" format="hex" (ngModelChange)="formToSave2()"
                            (onChange)="updateSecondaryColor($event.value)" class="w-full"></p-colorPicker>
                    </div>
                </div>
            </div>
            <!---->

        </div>
        <!-- <div class="card mt-0">
            <div class="text-900 text-xl font-semibold mb-2">Modo de Visualização</div>
            <div class="flex flex-column">
                <div class="col-12 mt-4 mb-2 p-0">
                    <div class="flex align-items-center gap-2">
                        <p-inputSwitch [(ngModel)]="darkMode" (onChange)="toggleTheme()"></p-inputSwitch>
                        <label class="ml-2">Modo Dark</label>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="card mt-0  ">
            <div class="text-900 text-xl font-semibold mb-2">Notificações</div>
            <div class="col-12 p-0 mb-2">
                <div>Ative e desative as notificações que gostaria de receber</div>
            </div>
            <div class="flex flex-column">
                <div class="col-12 mt-4 mb-2 p-0">
                    <div class="flex align-items-center gap-2">
                        <p-inputSwitch [(ngModel)]="push_news_and_offers"
                            (onChange)="onChangePushNews()"></p-inputSwitch>
                        <label class="ml-2">Novidades e ofertas</label>
                    </div>
                </div>


                <div class="col-12 mb-2 p-0">
                    <div class="flex align-items-center gap-2">
                        <p-inputSwitch [(ngModel)]="push_slick_comment"
                            (onChange)="onChangePushComment()"></p-inputSwitch>
                        <label class="ml-2">Comentários recebidos em <b>Slicks®</b></label>
                    </div>
                </div>

                <div class="col-12 mb-2 p-0">
                    <div class="flex align-items-center gap-2">
                        <p-inputSwitch [(ngModel)]="push_account_limits"
                            (onChange)="onChangePushLimits()"></p-inputSwitch>
                        <label class="ml-2">Limites de conta</label>
                    </div>
                </div>
            </div>


        </div>

    </div>

</div>
<div class="grid h-full" *ngIf="activeOption == 2">
    <div class="col-12 xl:col-6">
        <div class="card">
            <div class="flex align-items-start justify-content-between mb-2">
                <span class="text-900 text-xl font-semibold">Endereço Fiscal da Loja</span>
            </div>
            <div>
                <div>Essas informações serão exibidas para seus clientes apenas em caso de vendas e pagamentos
                    realizados junto à plataforma.
                </div>
            </div>
            <div class="col-12 mb-4 mt-4 p-0">
                <label class="w-full ss-g-globalClassLabel">
                    País
                    <div class="p-inputgroup mt-2">

                    </div>
                </label>
                <p-dropdown [options]="countries" [(ngModel)]="country" (onChange)="formToSave1()"
                    placeholder="Select a Country" optionLabel="name" class="w-full"
                    panelStyleClass="ss-l-country-panel">
                    <!-- Template para os itens da lista -->
                    <ng-template let-country pTemplate="item">
                        <div class="flex align-items-center">
                            <img src="assets/demo/images/flag/flag_placeholder.png"
                                [class]="'flag flag-' + country.code.toLowerCase()" alt="Flag" style="width:21px" />
                            <span class="ml-2">{{country.name}}</span>
                        </div>
                    </ng-template>
                    <!-- Template para o item selecionado -->
                    <ng-template let-country pTemplate="selectedItem">
                        <div class="flex align-items-center">
                            <img src="assets/demo/images/flag/flag_placeholder.png"
                                [class]="'flag flag-' + country.code.toLowerCase()" alt="Flag" style="width:21px" />
                            <span class="ml-2">{{country.name}}</span>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
            <div class="col-12 mt-4 mb-4 p-0">
                <label class="w-full ss-g-globalClassLabel">
                    CEP
                    <div class="p-inputgroup mt-2">
                        <input (ngModelChange)="formToSave1(); checkCEP();" type="text" id="cep" pInputText
                            class="w-full" (keypress)="allowOnlyNumbers($event)" [(ngModel)]="zipcode"
                            (input)="updateZipCode($event)" (keypress)="filterNonNumeric($event)">
                    </div><!---->
                </label>
            </div>
            <div class="col-12 mt-6 p-0">
                <div class="grid mx-0">
                    <div class="col-8 mb-2 p-0">
                        <label for="address" class="ss-g-globalClassLabel">Logradouro</label>
                        <input (ngModelChange)="formToSave1()" [id]="address" class="mt-2 w-full" pInputText
                            [(ngModel)]="address" placeholder="ex: Rua dos Guararapes" type="text" />
                    </div>
                    <div class="col-1 mb-2 p-0"></div>
                    <div class="col-3 mb-4  p-0">
                        <label for="nro" class="ss-g-globalClassLabel">Nro</label>
                        <input (ngModelChange)="formToSave1()" [id]="nro" class="mt-2 w-full" type="text" pInputText
                            [(ngModel)]="nro" placeholder="ex: 15" />
                    </div>
                </div>
            </div>
            <div class="col-12 mt-4 p-0">
                <div class="grid mx-0">
                    <div class="col-8 mb-2 p-0">
                        <label for="neighborhood" class="ss-g-globalClassLabel">Bairro</label>
                        <input (ngModelChange)="formToSave1()" [id]="neighborhood" class="mt-2 w-full" pInputText
                            [(ngModel)]="neighborhood" placeholder="ex: Vila dos Pássaros" type="text" />


                    </div>
                    <div class="col-1 mb-2 p-0"></div>
                    <div class="col-3 mb-4  p-0">
                        <label for="complement" class="ss-g-globalClassLabel">Compl.</label>
                        <input (ngModelChange)="formToSave1()" [id]="complement" class="mt-2 w-full" type="text"
                            pInputText [(ngModel)]="complement" placeholder="ex: AP 15" />
                    </div>
                </div>
            </div>
            <div class="col-12 mt-4 p-0">
                <div class="grid mx-0">
                    <div class="col-8 mb-2 p-0">
                        <label for="city" class="ss-g-globalClassLabel">Cidade</label>
                        <input (ngModelChange)="formToSave1()" [id]="city" class="mt-2 w-full" pInputText
                            [(ngModel)]="city" placeholder="ex: São Paulo" type="text" />


                    </div>
                    <div class="col-1 mb-2 p-0"></div>
                    <div class="col-3 mb-4  p-0">
                        <label for="state" class="ss-g-globalClassLabel">Estado</label>
                        <div class="mt-2"></div>
                        <p-dropdown (ngModelChange)="formToSave1()" [options]="states" [(ngModel)]="selectedState"
                            styleClass="w-full" optionLabel="label" (onChange)="onStateChange()"></p-dropdown>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 xl:col-6">
        <div class="card mt-0  ">
            <div class="text-900 text-xl font-semibold mb-2">Contato</div>
            <div class="col-12 p-0 mb-2">
                <div>Essas informações serão exibidas para seus clientes apenas em caso de vendas e pagamentos
                    realizados juntos à plataforma</div>
            </div>
            <div class="grid mx-0 mt-2">
                <div class="col-3 col-md-2 mb-2 p-0">
                    <label for="phoneDDD" class="ss-g-globalClassLabel">DDD</label>
                    <input [id]="phoneDDD" class="mt-2 w-full" inputmode="numeric" pInputText
                        (input)="limitInput($event)" (keydown)="preventE($event)" [(ngModel)]="phoneDDD"
                        (keypress)="allowOnlyNumbers($event)" placeholder="ex: 99" type="text"
                        (ngModelChange)="formToSave1()" />
                </div>
                <!-- Adicionando margem direita para espaçamento -->
                <div class="col-1 p-0"></div>
                <div class="col-8 col-md-9 mb-4 p-0">
                    <label for="phone" class="ss-g-globalClassLabel">Telefone</label>
                    <input [id]="phone" class="mt-2 w-full" type="text" pInputText inputmode="numeric"
                        (input)="limitPhoneLength($event, 10)" (keypress)="allowOnlyNumbers($event)" [(ngModel)]="phone"
                        placeholder="ex: 99999-9999" (ngModelChange)="formToSave1()" />
                </div>
            </div>

            <div class="col-12 mt-2 p-0">
                <div class="grid mx-0 mt-2">
                    <div class="col-3 col-md-2 mb-2 p-0"> <!-- Ajuste para proporção menor para DDD -->
                        <label for="whatsDDD" class="ss-g-globalClassLabel">DDD</label>
                        <input [id]="whatsDDD" class="mt-2 w-full" inputmode="numeric" pInputText
                            (input)="limitInput($event)" (keydown)="preventE($event)" [(ngModel)]="whatsDDD"
                            (keypress)="allowOnlyNumbers($event)" placeholder="ex: 99" type="text"
                            (ngModelChange)="formToSave1()" />
                    </div>
                    <div class="col-1 p-0"></div> <!-- Espaçamento entre os campos -->
                    <div class="col-8 col-md-9 mb-4 p-0"> <!-- Ajuste para maior largura para WhatsApp -->
                        <label for="whatsapp" class="ss-g-globalClassLabel">Whatsapp</label>
                        <input [id]="whatsapp" class="mt-2 w-full" type="text" pInputText inputmode="numeric"
                            [(ngModel)]="whatsapp" (input)="limitPhoneLength($event, 10)"
                            (keypress)="allowOnlyNumbers($event)" placeholder="ex: 99999-9999"
                            (ngModelChange)="formToSave1()" />
                    </div>
                </div>
            </div>

            <div class="col-12 mb-2 mt-2 p-0">
                <label class="w-full ss-g-globalClassLabel">
                    Email
                    <div class="p-inputgroup mt-2">
                        <input type="email" id="email" pInputText class="w-full" [(ngModel)]="email"
                            (ngModelChange)="formToSave1()">
                    </div>
                </label>
            </div>

            <!---->


            <!---->

        </div>

    </div>
</div>
<div class="grid h-full" *ngIf="activeOption == 3">
    <div class="col-12 xl:col-6">
        <div class="card">
            <div class="flex align-items-start justify-content-between mb-2">
                <span class="text-900 text-xl font-semibold">Domínios permitidos </span>
            </div>
            <div>
                <div>Adicione domínios permitidos a executar suas APIs e Players. IPs não são permitidos.
                </div>
            </div>
            <div class="col-12 mb-4 mt-4 p-0" #domainsContainer>
                <div class="p-fluid ">
                    <p-chips [(ngModel)]="valuesDoms" class="" (ngModelChange)="formToSave2()" separator=","
                        placeholder="Insira uma tag e aperte ',' ou ⏎" (ngModelChange)="showSlickClearFunction()"
                        #chipsComponent>
                    </p-chips>
                </div>
                <div *ngIf="showClearDoms" class="mt-2">
                    <a class="text-base cursor-pointer " (click)="clearSlickMaps()">
                        <i class="pi pi-times text-xs mr-1"></i>Limpar domínios
                    </a>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="flex align-items-start justify-content-between mb-2">
                <span class="text-900 text-xl font-semibold">Pixels</span>
            </div>
                        <div class="mb-4">
                <div>Rastreie seus usuários e crie campanhas poderosas</div>
            </div>
            <app-pixel-manager [storeId]="store_id"></app-pixel-manager>
        </div>
    </div>
    <div class="col-12 xl:col-6">
        <div class="card mt-0  ">
            <div class="text-900 text-xl font-semibold mb-2">Localhost</div>
            <div class="col-12 p-0 mb-2">
                <div>Permitir conexões de localhost ou qualquer porta para fins de testes e integração</div>
            </div>
            <!---->
            <div class="col-12 p-0 grid mx-0 w-full">
                <div class="col-12 mb-2 mt-4 p-0">
                    <div class="flex align-items-center gap-2">
                        <p-inputSwitch binary="true" class="mr-2 ss-l-switch-position3" [(ngModel)]="localhost"
                            [ngModelOptions]="{standalone: true}" (ngModelChange)="formToSave2()"></p-inputSwitch>
                        <label>Localhost[Qualquer porta]</label>
                    </div>
                </div>
            </div>
            <!---->
        </div>

        <div class="card mt-0">
            <div class="text-900 text-xl font-semibold mb-3">Iframe</div>
            <p class="mb-4">
                Você pode inserir o seu player <strong>slicksell</strong> com todos seus slicks publicados em qualquer
                site ou aplicativo.
                Basta inserir o script abaixo no head do seu site ou GTM.
            </p>

            <!-- Linha com dropdown e input de cópia -->
            <div class="grid mb-4">
                <div class="col-12 md:col-6 pr-2">
                    <label for="resolutionSelect" class="ss-g-globalClassLabel mb-2">Resolução (pixels)</label>
                    <div class="mb-2"></div>
                    <p-dropdown [options]="resolutions" [(ngModel)]="selectedResolution" appendTo="body"
                        placeholder="Selecione uma resolução" (ngModelChange)="onResolutionChange($event)"></p-dropdown>
                </div>

                <div class="col-12 md:col-6 pl-2">
                    <label class="ss-g-globalClassLabel mb-2">Script</label>
                    <div class="mb-2"></div>
                    <div class="p-inputgroup">
                        <input type="text" pInputText [(ngModel)]="widget_share" readonly class="custom-input">
                        <button pButton pRipple type="button" icon="pi pi-copy" (click)="copiarWidget()"
                            class="ss-l-custom-button"></button>
                    </div>
                </div>
            </div>

            <!-- Prévia -->
            <p-panel header="Prévia" [toggleable]="true" [collapsed]="true">
                <div class="select-button-wrapper">
                    <p-selectButton class="mt-5 ss-g-selectButton-50" [options]="deviceOptions"
                        (onChange)="onDeviceChange()" [(ngModel)]="selectedDevice" optionLabel="name">
                        <ng-template let-option pTemplate="item">
                            <div class="flex align-items-center justify-content-center w-full">
                                <i [ngClass]="option.icon" class="mr-2"></i>
                                <span class="font-bold">{{ option.name }}</span>
                            </div>
                        </ng-template>
                    </p-selectButton>
                </div>

                <!-- iframe container wrapper centralizador -->
                <!-- Wrapper centralizador -->
                <div class="flex justify-content-center">
                    <div class="ss-l-video-container-widget col-12" [ngStyle]="getAspectRatioStyles()">
                        <img *ngIf="previewImagePath" [src]="previewImagePath" alt="Prévia" width="100%" height="100%"
                            style="border-radius: 12px;" />
                    </div>
                </div>

            </p-panel>

        </div>
    </div>
    <!-- <div class="col-12 xl:col-6">
        
    </div> -->

</div>





<app-dialog-aguarde [visible]="displayAguarde"></app-dialog-aguarde>


<p-sidebar [(visible)]="displaySidebar" #sidebar id="ss-l-sideBarBottom" class="ss-g-custom-sidebar-width"
    position="bottom" [modal]="false">
    <ng-template pTemplate="footer">
        <div class="w-full  text-right p-0">
            <button pButton pRipple label="Cancelar" (click)="cancelButton()" class="p-button-outlined mr-2"></button>
            <button pButton pRipple label="Salvar" [disabled]="btnSave" [loading]="saveBtnForm" (click)="saveBtn()"
                class="primary"></button>
        </div>
    </ng-template>
</p-sidebar>



